import KpiCard from './KpiCard';

export default KpiCard;
